const errorMessage = {
  NO_CHANGES: 'No changes found !',
};

export { errorMessage };
